import { type ReactNode } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { Tooltip } from '@zep-us/zus';
import { QuizBankSearchHitText } from './QuizBankSearchHitText';

/**
 * 성취기준 설명 툴팁. 필터 패널과 목록이 모두 `overflow-y-auto` 라 Portal 이 필요한데,
 * zus `Tooltip` 은 Portal 을 내보내지 않아 radix 에서 직접 가져온다.
 */
export const QuizBankStandardTooltip = ({
  description,
  children
}: {
  description: string;
  children: ReactNode;
}) => <Tooltip.Provider data-sentry-element="unknown" data-sentry-component="QuizBankStandardTooltip" data-sentry-source-file="QuizBankStandardCode.tsx">
    <Tooltip.Root data-sentry-element="unknown" data-sentry-source-file="QuizBankStandardCode.tsx">
      <Tooltip.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="QuizBankStandardCode.tsx">{children}</Tooltip.Trigger>
      <TooltipPrimitive.Portal data-sentry-element="unknown" data-sentry-source-file="QuizBankStandardCode.tsx">
        <Tooltip.Content side="top" align="start" arrow data-sentry-element="unknown" data-sentry-source-file="QuizBankStandardCode.tsx">
          {description}
        </Tooltip.Content>
      </TooltipPrimitive.Portal>
    </Tooltip.Root>
  </Tooltip.Provider>;
interface QuizBankStandardCodeProps {
  code: string;
  description: string;
  /** 검색어가 이 코드였다 — 단원명과 같은 `data-search-hit` 마크로 통째로 칠한다 */
  hit?: boolean;
  onClick?: () => void;
}
const NO_HIT_TERMS: readonly string[] = [];

/** 카드 푸터의 성취기준 배지 — 누르면 검색어가 되고, hover 하면 설명이 뜬다. */
export const QuizBankStandardCode = ({
  code,
  description,
  hit = false,
  onClick
}: QuizBankStandardCodeProps) => <QuizBankStandardTooltip description={description} data-sentry-element="QuizBankStandardTooltip" data-sentry-component="QuizBankStandardCode" data-sentry-source-file="QuizBankStandardCode.tsx">
    <button type="button" className="max-w-full truncate rounded-xs text-body-sm-semibold tabular-nums text-alternative underline-offset-2 hover:underline focus-visible:focus-ring" onClick={event => {
    // 카드 전체가 선택 토글이라 배지 클릭이 번지지 않게 막는다.
    event.stopPropagation();
    onClick?.();
  }}>
      <QuizBankSearchHitText text={code} hitTerms={hit ? [code] : NO_HIT_TERMS} data-sentry-element="QuizBankSearchHitText" data-sentry-source-file="QuizBankStandardCode.tsx" />
    </button>
  </QuizBankStandardTooltip>;